/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Fragment, useContext } from "react";
import { RichTextPreview } from "cms/rich-text/simplicity-composer-tiptap";
import { ContentZoneContext } from "cms/components/context";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";
import { isArrayNotEmpty, isStringNotEmpty } from "utils/empty-exists";
import { ImageGalleryGrid } from "./image_gallery_grid";
import { ImageGalleryCollage } from "./image_gallery_collage";
import { ImageGalleryCarousel } from "./image_gallery_carousel";
import { ImageGalleryFilmstrip } from "./image_gallery_filmstrip";
import { isRichTextEmpty } from "cms/rich-text/richtext-utils";
import { IMAGE_GALLERY_TYPES } from "./utils";

const ImageGalleryComponentDisplay = () => {

    const { component } = useContext(ContentZoneContext);
    const {
        guid,
        title,
        description,
        image_gallery,
        galleryType
    } = component || {};

    const hasContent = isArrayNotEmpty(image_gallery);

    return (
        <div className='simplicity-image-list'>
            {!hasContent &&
                <EmptyContentMessage
                    hasContent={hasContent}
                    component={component}
                />
            }
            {hasContent &&
                <Fragment>

                    {isStringNotEmpty(title) &&
                        <h2>{title}</h2>
                    }

                    {!isRichTextEmpty(description) &&
                        <RichTextPreview richtext={description} />
                    }

                    <div className='blocks'>
                        <div
                            id={`image-list-${guid}`}
                            className='block block-bean'
                        >
                            <div className='content'>
                                {galleryType === IMAGE_GALLERY_TYPES.FILMSTRIP &&
                                    <ImageGalleryFilmstrip
                                        image_gallery={image_gallery}
                                    />
                                }
                                {galleryType === IMAGE_GALLERY_TYPES.CAROUSEL &&
                                    <ImageGalleryCarousel
                                        image_gallery={image_gallery}
                                    />
                                }
                                {galleryType === IMAGE_GALLERY_TYPES.GRID &&
                                    <ImageGalleryGrid
                                        image_gallery={image_gallery}
                                    />
                                }
                                {galleryType === IMAGE_GALLERY_TYPES.COLLAGE &&
                                    <ImageGalleryCollage
                                        image_gallery={image_gallery}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </Fragment>
            }
        </div>
    );
};

ImageGalleryComponentDisplay.displayName = "ImageGalleryComponentDisplay";
export { ImageGalleryComponentDisplay };
